import './InsightList.scss';

import { InsightCard } from '../InsightCard/InsightCard';

export const InsightList = ({ insights, onClick }) => {
  return (
    <div className="insight-list">
      {insights?.map((insight, index) => (
        <InsightCard key={index} insight={insight} onClick={onClick} />
      ))}
    </div>
  );
};
